import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import ItemGrid from './itemList';
import Authorization from './authorization';
import MessageGrid from '../purchaseRequisition/messageGrid';
import "../../Assets/styles/addmenu.css"
import { FaAngleLeft } from "react-icons/fa6";
import moment from 'moment';
import ItemGridView from './itemGridView';
import { getCompany } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';

const PurchaseOrderView = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [SupplierTab, setSupplierTab] = useState(false);
    const [POTab, setPOTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [usersDetails, setUser] = useState([]);
    const [formData, setformData] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [isXtreamCompany, setXtreamCompany] = useState(false);
    const Company = useSelector(getCompany);

    const location = useLocation();
    const itemData = location.state;
    useEffect(() => {
        getApprovalUser()
    }, []);
    useEffect(() => {
        const item = location.state;
        const getCurrency = async () => {
            const apiService = new ApiService()
            let param = `?Id=${item?.docno || item?.pOrderNo}`
            const selectedPO = await apiService.getApiParamater("GET_PO", param);
            debugger
            setformData(selectedPO?.data?.result?.[0]);
        }
        if (item?.docno || item?.pOrderNo) {
            getCurrency()
        }
    }, [location.state]);

    useEffect(() => {
        checkCompanyName();
    }, [Company]);

    const getApprovalUser = async () => {
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('DocNo', itemData?.docno || itemData?.pOrderNo);
            params.append('DocumentType', "Purchase Order");
            let res = await apiService.get('GET_CURRENCY_MASTER')
            const filteredDenominations = res?.data?.result?.find(currency => currency?.isDefault === true);
            if (filteredDenominations) {
                setSelectedCurency({ label: filteredDenominations.code, value: filteredDenominations });
            }
            const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
            setUser(response.data.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };

    const checkCompanyName = () => {
        const DB = localStorage.getItem('DataBase');
        const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
        const defaultCompany = companies.find(comp => comp.dataDB === DB);
        const companyName = defaultCompany?.companyName?.toLowerCase() || '';
        const isXtreamCashier = companyName.includes('accountcode') || companyName.includes('kanoo');
        setXtreamCompany(isXtreamCashier);
    };
    return (
        <div className='px-4'>
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Purchase Order</h5>
                <div className='d-flex gap-3'>
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Purchase Order Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group justify-content-between row pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="InvoiceNO" className="form-label">LPO Type</label>
                                <input
                                    className="form-Input w-70"
                                    value={formData?.fax}
                                    name="fax"
                                    disabled
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="InvoiceNO" className="form-label">Purchase Order No</label>
                                <input
                                    className="form-Input w-70"
                                    value={itemData?.docno || itemData?.pOrderNo}
                                    name="poNumber"
                                    disabled
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="deliveryDate" className="form-label">Delivery Date</label>
                                <input disabled
                                    className="form-Input w-70"
                                    type='date'
                                    value={formData?.deliveryDate?.split('T')[0]}
                                />
                            </div>
                        </div>
                        <div className="form-group row justify-content-between pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="Currency" className="form-label">Currency </label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    value={[{ label: formData?.currencyCode, value: formData?.currencyCode }]}
                                    isDisabled
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="DocumentDate" className="form-label">Document Date</label>
                                <input disabled
                                    className="form-Input w-70"
                                    type='date'
                                    value={formData?.docDate?.split('T')[0]}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="deliveryPoint" className="form-label">Delivery Point</label>
                                <input
                                    type="text"
                                    className="form-Input w-70" disabled
                                    value={formData?.deliveryPoint}
                                />
                            </div>
                        </div>
                        <div className="form-group row justify-content-between pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="ExchangeRate" className="form-label">Exchange Rate </label>
                                <input
                                    type="number"
                                    className="form-Input w-70"
                                    disabled
                                    id="exchangeRate"
                                    value={formData?.exchangeRate}
                                    name="exchangeRate"
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="requisitionNo" className="form-label">Requisition No</label>
                                <input
                                    className="form-Input w-70" name='requisitionNo'
                                    id="requisitionNo" disabled
                                    value={formData?.requisitionNo}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="location" className="form-label">Location</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="location" disabled
                                    value={formData?.location}
                                    name="location"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="Description" className="form-label">Description</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="Description" disabled
                                    value={formData?.description}
                                    name="Description"
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="RequisitionType" className="form-label">Requisition Type</label>
                                <Select isDisabled
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    value={[{ label: formData?.docId, value: formData?.docId }]}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="contactPerson" className="form-label">Contact Person</label>
                                <input
                                    type="text" disabled
                                    className="form-Input w-70"
                                    id="contactPerson"
                                    value={formData?.contactPerson}
                                    name="contactPerson"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="Remarks" className="form-label">Remarks</label>
                                <input
                                    type="text" disabled
                                    className="form-Input w-70"
                                    id="Remarks"
                                    value={formData?.remarks}
                                    name="Remarks"
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="QuotationReq" className="form-label">Quotation Req</label>
                                <input disabled
                                    className="form-Input w-70"
                                    value={formData?.quotationRef}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="ContactNo" className="form-label">Contact No</label>
                                <input
                                    type="number"
                                    className="form-Input w-70"
                                    id="ContactNo" disabled
                                    value={formData?.contractNo}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="Description" className="form-label">Pay OrderType</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    value={[{ label: formData?.poType, value: formData?.poType }]}
                                    isDisabled
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="BuyerName" className="form-label">Buyer Name</label>
                                <input
                                    type="text" disabled
                                    className="form-Input w-70"
                                    value={formData?.modifiedBy}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="BuyerName" className="form-label">Delivery Note No</label>
                                <input
                                    type="text" disabled={itemData.eye === true ? true : false}
                                    className="form-Input w-70"
                                    id="deliveryNote"
                                    name="deliveryNote"
                                />
                            </div>
                            <div className='col-1 px-5'></div>
                            <div className='col-lg-2 p-2 mt-3 brderbox center'><a disabled>Attachment</a></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Supplier Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row justify-content-between pb-3">
                            <div className="col d-flex align-items-center">
                                <label htmlFor="inventoryAccountCode" className="form-label">Vendor ID</label>
                                <Select
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    isDisabled
                                    value={[{ label: formData?.vendorId, value: formData?.vendorId }]}
                                />
                            </div>
                            <div className="col d-flex align-items-center">
                                <label htmlFor="inventoryAccountCode" className="form-label">Vendor Name</label>
                                <Select
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    isDisabled
                                    value={[{ label: formData?.vendorName, value: formData?.vendorName }]}
                                />
                            </div>
                            <div className="col d-flex align-items-center">
                                <label htmlFor="inventoryAccountCode" className="form-label">Payment terms</label>
                                <Select
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    value={[{ label: formData?.terms, value: formData?.terms }]}
                                    isDisabled
                                />
                            </div>
                        </div>
                        <div className="form-group row  pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label">Supplier Dept</label>
                                <Select
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })} isDisabled
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="Property" className="form-label">Supplier Contact</label>
                                <input disabled
                                    type="number"
                                    className="form-Input w-75"
                                    id="SupplierContact"
                                    value={formData?.attention}
                                    name="SupplierContact"
                                />
                            </div>
                            <div className="col-4 pt-1 d-flex justify-content-between">
                                <div className="d-flex justify-content-between">
                                    <div className="form-check">
                                        <input disabled
                                            style={{ width: "26px", height: "26px" }}
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={formData?.costCenter5 === "excluded" ? true : false}
                                        />
                                        <label className="form-check-label mx-2 mt-1">Vat Excluded</label>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <div className="form-check">
                                        <input disabled
                                            style={{ width: "26px", height: "26px" }}
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={formData?.isDiscountPercentage}
                                        />
                                        <label className="form-check-label mx-2 mt-1">Discount in %</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
                    <div className="h6 pt-1">Cost Center Details</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row justify-content-between pb-3">
                            <div className="col d-flex align-items-center">
                                <label htmlFor="inventoryAccountCode" className="form-label">Property</label>
                                <Select
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    isDisabled
                                    value={[{ label: formData?.costCenter1, value: formData?.costCenter1 }]}
                                />
                            </div>
                            <div className="col d-flex align-items-center">
                                <label htmlFor="inventoryAccountCode" className="form-label">Unit</label>
                                <Select
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    isDisabled
                                    value={[{ label: formData?.costCenter2, value: formData?.costCenter2 }]}
                                />
                            </div>
                            <div className="col d-flex align-items-center">
                                <label htmlFor="costCenter3" className="form-label me-2">{isXtreamCompany === false ? "Cost Center 3" : "Nature of Job"}</label>
                                <Select
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    isDisabled
                                    value={[{ label: formData?.costCenter3, value: formData?.costCenter3 }]}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex align-items-center">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">{isXtreamCompany === false ? "Cost Center 4" : "Work Order No"}</label>
                                <Select
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    isDisabled
                                    value={[{ label: formData?.costCenter4, value: formData?.costCenter4 }]}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Items
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Terms
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 3 ? 'active' : ''}`}
                            onClick={() => handleTabClick(3)}
                        >
                            Recommendation
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid-1 brderbox2 p-4 mb-3">
                {gridVisibility[0] && (
                    <ItemGridView itemData={formData} currencyPrecision={SelectedCurrency?.value?.precision} />
                )}
                {gridVisibility[1] && (
                    <Authorization usersDetails={usersDetails} />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border">
                        <MessageGrid />
                    </div>
                )}
                {gridVisibility[3] && (
                    <div className="grid-3 border">
                        <MessageGrid />
                    </div>
                )}
            </div>
        </div >

    )
}

export default PurchaseOrderView